import { CubeSaveGenericServices } from "./api-connector";
import { QS } from "@green24/npm-javascript-utils";

class HealthServices extends CubeSaveGenericServices {
	sendHeartbeat(frontendID, additionalData) {
		return this.sendRequest({
			url: `${this.url}/heartbeat${QS({frontendID})}`,
			method: "POST",
			body: additionalData,
		});
	}
}

export const healthServices = new HealthServices(`/health`);
